import { mergeQueryKeys } from "@lukemorales/query-key-factory";
import { purchaseOpportunity } from "./purchaseOpportunities";
import { user } from "./user";
import { schedule } from "./schedule";
import { gameRequestCounts } from "./gameRequestCounts";
import { departments } from "./departments";

export const queries = mergeQueryKeys(purchaseOpportunity, user, schedule, gameRequestCounts, departments);
